const menus = [

    {
        id: 1,
        name: 'Accueil',
        links: '/',
    },
    {
        id: 2,
        name: 'Qui sommes-nous',
        links: '#nous',
    },
    {
        id: 3,
        name: 'Thème',
        links: '#theme',
    },
    {
        id: 4,
        name: 'Char',
        links: '#char',
    },
    {
        id: 5,
        name: 'Comité',
        links: '#comite',
    },
    {
        id: 6,
        name: 'FAQ',
        links: '#faq',
    },
    {
        id: 7,
        name: 'Contact',
        links: 'contact',
    },
    
]

export default menus;